import { gql } from '@apollo/client'
import { DeviceType } from 'models/device'

export type DeviceTypeRes = {
  res: {
    content: DeviceType[],
    count: number,
    offset: number,
    pageSize: number,
  },
}
export type DeviceTypeVars = {
  clubId: string,
  serialIds: string[] | null,
  allDevices: boolean,
  first?: number,
  skip?: number,
  sort?: string,
}
export const DEVICES = gql`
  query Devices(
    $clubId: ID!,
    $serialIds: [ID],
    $allDevices: Boolean,
    $first: Int,
    $skip: Int,
    $sort: String,
  ) {
    res: devices(
      clubId: $clubId,
      serialIds: $serialIds,
      allDevices: $allDevices,
      first: $first,
      skip: $skip,
      sort: $sort,
    ) {
      content {
        id
        createdOn
        updatedOn
        deviceId
        serialId
        uniqueId
        active
        plan
        athlete {
          id
          name
          firstName
          lastName
        }
      }
      count
      offset
      pageSize
    }
  }
`

export type DeviceSalesTypeRes = {
  res: {
    id: string,
    device: DeviceType,
    plan: string,
    contract: string,
    deviceExp: string | null,
  }[],
}
export type DeviceSalesTypeVars = {
  clubId: string,
  uniqueId?: string | null,
}


export const DEVICE_SALES = gql`
    query DeviceSales(
        $clubId: ID!,
        $uniqueId: ID,
    ) {
        res: deviceSales(
            clubId: $clubId,
            uniqueId: $uniqueId,
        ) {
            id
            device {
                serialId
            }
            plan,
            contract,
            deviceExp,
            contract
        }
    }
`
